import moment from './moment'

/**
 * Format date to a day format: "Sunday"
 * @param {String} date
 * @param {String} dateFormat
 */
export default (date, dateFormat) =>
  moment(date, dateFormat, true).format('dddd')
